export const INCOME_RANGE_OPTIONS = [
  '0-50000',
  '50000-200000',
  '200000-500000',
  '500000 and above'
];

/** Map min/max income numbers to the display range label. */
export const getIncomeRange = (minIncome, maxIncome) => {
  const min = minIncome == null || minIncome === '' ? null : Number(minIncome);
  const max = maxIncome == null || maxIncome === '' ? null : Number(maxIncome);
  if (min == null || max == null || Number.isNaN(min) || Number.isNaN(max)) {
    return null;
  }

  if (min === 0 && max === 50000) return '0-50000';
  if (min === 50000 && max === 200000) return '50000-200000';
  if (min === 200000 && max === 500000) return '200000-500000';
  if (min === 500000 && max === 0) return '500000 and above';
  return null;
};

/** Map selected income range label to minIncome/maxIncome numbers. */
export const parseIncomeRange = (selectedIncome) => {
  switch (selectedIncome) {
    case '0-50000':
      return { minIncome: 0, maxIncome: 50000 };
    case '50000-200000':
      return { minIncome: 50000, maxIncome: 200000 };
    case '200000-500000':
      return { minIncome: 200000, maxIncome: 500000 };
    case '500000 and above':
      return { minIncome: 500000, maxIncome: 0 };
    default:
      return { minIncome: null, maxIncome: null };
  }
};
